import { render, staticRenderFns } from "./GroupImages.tab.vue?vue&type=template&id=2f07b214&scoped=true&"
import script from "./GroupImages.tab.vue?vue&type=script&lang=ts&"
export * from "./GroupImages.tab.vue?vue&type=script&lang=ts&"
import style0 from "./GroupImages.tab.vue?vue&type=style&index=0&id=2f07b214&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07b214",
  null
  
)

export default component.exports